// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_8n-0";
export var optionCard = "_8n-1";